module.exports = __webpack_public_path__ + "media/images/pic/labels/a2_2-65467bb62a28480bbe0815206967d2a6.png";